import React from "react";

const decisionStyle = (status) => {
  switch (status) {
    case "Return_Request_Approved":
      return { dot: "bg-emerald-500", text: "text-emerald-600", bg: "bg-emerald-50 border-emerald-200" };
    case "Return_Request_Rejected":
      return { dot: "bg-red-500", text: "text-red-600", bg: "bg-red-50 border-red-200" };
    default:
      return { dot: "bg-amber-500", text: "text-amber-600", bg: "bg-amber-50 border-amber-200" };
  }
};

const verificationStyle = (status) => {
  switch (status) {
    case "Approved":
      return "text-emerald-600";
    case "Rejected":
      return "text-red-600";
    default:
      return "text-amber-600";
  }
};

const dispatchLabel = (status) => {
  if (!status || status === "Not_Initiated") return null;
  return status.replace(/_/g, " ");
};

const ReturnListItem = ({ returnDoc, isActive, onClick }) => {
  const decision = decisionStyle(returnDoc.returnDecision?.status);
  const dispatchTxt = dispatchLabel(returnDoc.returnDispatch?.status);

  return (
    <div
      onClick={onClick}
      className={`group relative rounded-xl border cursor-pointer transition-all duration-200 overflow-hidden
        ${isActive
          ? "border-[#772037] bg-[#772037]/[0.03] shadow-md shadow-[#772037]/10"
          : "border-gray-200 bg-white hover:border-[#772037]/40 hover:shadow-sm"
        }`}
    >
      {/* Active left accent bar */}
      <div
        className={`absolute left-0 top-0 bottom-0 w-1 rounded-l-xl transition-all duration-200
          ${isActive ? "bg-gradient-to-b from-[#772037] to-[#CC234F]" : "bg-transparent group-hover:bg-[#772037]/20"}`}
      />

      <div className="pl-3 pr-3 pt-3 pb-3 ml-1">
        {/* Top row: icon + case id + decision badge */}
        <div className="flex items-start gap-3">
          <div
            className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 border text-lg
              ${isActive ? "bg-[#772037]/10 border-[#772037]/20" : "bg-gray-50 border-gray-100"}`}
          >
            {returnDoc.returnType === "Full_Order" ? "📦" : "🧩"}
          </div>

          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-1">
              <div className="min-w-0">
                <p className={`text-[10px] font-bold uppercase tracking-widest mb-0.5 ${isActive ? "text-[#772037]/70" : "text-gray-400"}`}>
                  {returnDoc.uniqueCaseId || `#${returnDoc._id?.slice(-6)}`}
                </p>
                <h3 className={`font-bold text-sm leading-tight truncate ${isActive ? "text-[#772037]" : "text-gray-800"}`}>
                  {returnDoc.orderId?.orderNumber || "Order"}
                </h3>
                <p className="text-xs text-gray-400 font-medium truncate mt-0.5">
                  {returnDoc.returnType === "Full_Order" ? "Full Order Return" : "Partial Return"}
                  {returnDoc.returnType === "Partial" && returnDoc.partialReturnPackets && (
                    <span className="ml-1 text-[9px] font-bold px-1 py-px rounded bg-gray-100 text-gray-500 uppercase">
                      {returnDoc.partialReturnPackets} packs
                    </span>
                  )}
                </p>
              </div>
              <span className={`text-[10px] font-bold flex-shrink-0 ${verificationStyle(returnDoc.preInvestigationVerification?.status)}`}>
                {returnDoc.preInvestigationVerification?.status === "Approved" ? "Approved by QQT" : "Pending QQT Approval"}
              </span>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="my-2.5 border-t border-dashed border-gray-100" />

        {/* Meta row */}
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <div className="flex items-center gap-1 text-gray-400">
            <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <span className="text-[10px] font-medium">
              {returnDoc.createdAt
                ? new Date(returnDoc.createdAt).toLocaleDateString("en-GB", { day: "numeric", month: "short" })
                : "—"}
            </span>
          </div>

          <div className="flex items-center gap-1.5 flex-wrap">
            <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-lg text-[10px] font-bold border ${decision.bg} ${decision.text}`}>
              <span
                className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${decision.dot} ${returnDoc.returnDecision?.status === "Return_Request_Pending" ? "animate-pulse" : ""
                  }`}
              />
              {returnDoc.returnDecision?.status === "Return_Request_Pending" ? "Return Decision Pending(OFM Verification)" : returnDoc.returnDecision?.status === "Return_Request_Approved" ? "Return Decision Approved (After OFM Verification)" : returnDoc.returnDecision?.status === "Return_Request_Rejected" ? "Return Decision Rejected (After OFM Verification)" : "—"}
            </span>
            {dispatchTxt && (
              <span className="inline-flex items-center gap-1 px-2 py-1 rounded-lg text-[10px] font-bold bg-blue-50 text-blue-600 border border-blue-200">
                🚚 {dispatchTxt}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnListItem;